import { useChangeWorkerAvatarMutation } from '@/graphql';
import ChangeAvatarModal from '@/modals/ChangeAvatarModal';

type Props = {
  workerId: string;
  currentAvatarUrl: string | null;
  onClose: () => void;
  onSuccess: () => void;
};

const ChangeAvatarWrapper = ({
  workerId,
  currentAvatarUrl,
  onClose,
  onSuccess,
}: Props) => {
  const [changeAvatar] = useChangeWorkerAvatarMutation();

  const handleUpload = async (avatarKey: string) => {
    await changeAvatar({
      variables: { avatarKey, workerId },
    });
    onSuccess();
  };

  return (
    <ChangeAvatarModal
      currentAvatarUrl={currentAvatarUrl}
      hideModal={onClose}
      onUpload={handleUpload}
    />
  );
};

export default ChangeAvatarWrapper;
